<template>
    <div id="result">
        <div class="header">
        </div>
        <div class="content">
            <div class="title">
                <p>你的签号为</p>
                <h2>{{contentData.title}}</h2>
            </div>
            <div class="riddle">
                <div class="riddle-one">
                    <div class="jieyue">
                        <p class="title"><span>解曰</span></p>
                        <p class="details" ref="details">
                            <span
                                    v-for="(item,index) in contentData.riddleOne.jieyueData"
                                    :key="index"
                            >{{item}}</span>
                        </p>
                    </div>
                    <div class="xianji" ref="xianji">
                        <p class="title"><span>仙机</span></p>
                        <ul class="xj-content">
                            <li v-for="(item,index) in contentData.riddleOne.xianjiData" :key="index">
                                <p v-for="list in item">
                                    <span>{{list}}</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="riddle-two">
                    <p>
                        <span v-for="(item,index) in contentData.riddleTwo" :key="index">{{item}}</span>
                    </p>
                </div>
                <div class="riddle-three">
                    <p>
                        <span v-for="(item,index) in contentData.riddleThree" :key="index">
                            {{item}}
                        </span>
                    </p>
                </div>
            </div>
            <div class="footer">
                <p>
                    <span>【签语】 </span>
                </p>
                <p>{{contentData.mean}}</p>
            </div>
        </div>
        <div class="info">
            <ul class="infolist" v-show="infoData[0]">
                <li v-for="(item,index) in infoData" :key="index">
                    <h3>
                        <span>{{item.title}}</span>
                    </h3>
                    <p v-html="item.content"></p>
                </li>
            </ul>
        </div>
        <div class="more-test">
            <p class="title">
                <span>更多测算</span>
            </p>
            <ul class="other-test">
                <li v-for="(item,index) in moretestData" :key="index" @click="handleMoreTest(item.links)">
                    <img :src="item.img" :alt="item.name">
                    <p v-text="item.title"></p>
                </li>
            </ul>
        </div>
        <div class="tese-again" @click="handlegohome">
            <p>再次请签</p>
        </div>
        <div class="sadtips" ref="sadtips">
            <img src="/img/sad.png" alt="">
            <p class="dec" ref="goBack">抱歉,{{sadData.info1}}</p>
            <p>
                <span class="timenum">{{sadData.gobacktime}}</span>后将跳转至{{sadData.info2}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "result",
        data() {
            return {
                contentData: {
                    title: '"六十四签"',
                    riddleOne:{
                        jieyueData:["屋下安身","祸从天降","早觉先防","免遭灾殃"],
                        xianjiData:[
                            ["疾病有灾险", "山坟宜改", "六甲惊", "公讼亏",],
                            ["交易中平", "家宅凶", "田蚕损", "移徙吉",],
                            ["婚姻不合", "自身险", "六畜衰", "失物凶",],
                            ["行人有阻", "求财虚", "寻人杳↵",]
                        ]
                    },
                    riddleTwo: [
                        ['若得贵人相引处', '那时财帛亦相随', '晨昏全赖佛扶持', '须是逢危却不危'],
                    ],
                    riddleThree: ['第六十二签', '唐僧得道', '中签寅宫'],
                    mean: '此卦神佛暗佑之象，凡事忍耐大吉也。',
                },
                infoData: [
                    {
                        title: '第六十二签典故',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '爱情婚姻',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '工作求职 创业事业',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '考试竞赛 升迁竞选',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '投资理财',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '经商生意',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '房产交易',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '治病健康',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '转换变更',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '求孕求子',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '官司诉讼',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '寻人寻物',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                    {
                        title: '远行国门',
                        content:'汉朝。会稽郡人氏姓朱。买臣。夫妻住于陋巷蓬门。家道贫苦。行歌诵书。砍柴卖钱度日。卖柴凭人估值。其妻嫌他贫苦。离他而去。买臣曰。吾年五十当富贵。即时自可报汝。其妻不听。适田夫后。五十岁时。汉武帝求贤。拜为会稽太守。其妻自悔有眼无珠。要求再合。愿降为婢妾。伏侍终身。买臣命取水一桶。泼于阶下曰。若水可收。则可复合。覆水难收示不能再合。念结发之情。买臣呼车载其夫妇。判后园隙地与妻及其夫耕种自食。其妻遂投河而死。与夫钱以葬之。'
                    },
                ],
                moretestData: [],
                qianOid: '382019122711157741732487',
                sadData: {
                    info1: '',
                    gobacktime: '5',
                    info2: ''
                }
            }
        },
        methods: {
            handleSetFontSize() {
                let oHtml = document.getElementById('gyjq');
                fontSize();
                window.onresize = fontSize;

                function fontSize() {
                    oHtml.style.fontSize = window.innerWidth >= 750 ? 75 + 'px' : oHtml.style.fontSize;
                }
            },
            handlegohome() {
                // this.$router.push({path: '/'});
            },
            handleGetData() {
                const _this = this;
                let sadData = _this.sadData;
                this.Axios.post(`?ct=app&ac=getfind&oid=${_this.$route.query.oid}`)
                    .then(res => {
                        if (res.data.status === 0) {
                            let sadtips = this.$refs.sadtips;
                            let url = ``;
                            sadtips.style.display = 'block';
                            sadData.info1 = res.data.data;
                            if (res.data.data === '没有该订单') {
                                sadData.info2 = '首页'
                                url = '/'
                            } else if (res.data.data === '该订单暂未付费!') {
                                sadData.info2 = '支付页面';
                                url = `/order?oid=${_this.$route.query.oid}`
                            }
                            let timer2 = setInterval(() => {
                                if (sadData.gobacktime === 0) {
                                    clearInterval(timer2)
                                    sadtips.style.display = 'none';
                                    _this.$router.push({
                                        path: url
                                    })
                                }
                                sadData.gobacktime--;
                            }, 1000);
                        }
                        let data = res.data.data;
                        //标题
                        _this.contentData.title = data.qid + "签";
                        _this.contentData.mean = data.qy;

                        //第一部分的自适应处理
                        (function () {
                            _this.$nextTick(()=>{
                                let details = _this.$refs.details,
                                    detailsWidth = 0,
                                    xianji = _this.$refs.xianji,
                                    xianjiWidth = 0,
                                    fontWidth = .7;

                                let strlen = details.children[0].innerHTML.length,
                                    numlen = details.children.length;
                                if (strlen > 4) {
                                    detailsWidth = Math.ceil(numlen / 2) * fontWidth;
                                    details.style.width = `${detailsWidth}rem`;
                                    xianjiWidth = 5.35 - detailsWidth - .4;
                                    xianji.style.width = `${xianjiWidth}rem`;
                                }
                                if (strlen <= 4) {
                                    detailsWidth = Math.ceil(numlen / 4) * fontWidth;
                                    details.style.width = `${detailsWidth}rem`;
                                    xianjiWidth = 5.35 - detailsWidth - .4;
                                    xianji.style.width = `${xianjiWidth}rem`;
                                }
                            })
                        })();
                        //第一部分文字处理
                        (function () {
                            let riddleOne=_this.contentData.riddleOne,
                                arr=[];
                            riddleOne.jieyueData=data.jie;
                            data.xianji.forEach((ele,index)=>{
                                arr[Math.floor(index/4)]=arr[Math.floor(index/4)]?arr[Math.floor(index/4)]:[]
                                arr[Math.floor(index/4)].push(ele);
                            })
                            riddleOne.xianjiData=arr;
                        })();
                        //第二部分文字
                        _this.contentData.riddleTwo = data.title2;
                        //第三部分文字
                        data.title1 && data.title1.unshift(_this.contentData.title);
                        _this.contentData.riddleThree = data.title1;
                        //相关故事的文字挂载
                        (function () {
                            let arr1 = [];
                            //签数标题
                            _this.infoData[0].title = `第${_this.contentData.title}典故`;
                            //内容挂载
                            Object.keys(data).forEach((ele, index) => {
                                if (index >= 7 && index <= 19) {
                                    arr1.push(data[ele])
                                }
                            })
                            arr1.forEach((ele, index) => {
                                _this.infoData[index].content = ele;
                            })
                        })();
                        //更多测算部分
                        (function () {
                            _this.moretestData = data.more;
                        })();
                    })
            },
            //更多页面跳转
            handleMoreTest(url) {
                window.open(url, '_self')
                document.cookie = 'CookieName=CookieValue;SameSite=Lax'
            }
        },
        created() {
            this.handleSetFontSize();
            this.handleGetData();
        },
        mounted() {
            console.log(this.$data)
        }
    }
</script>
<style scoped lang="scss">
    .clearfix::after {
        content: '';
        display: block;
        clear: both;
    }

    #result {
        position: relative;
        overflow: hidden;
        max-width: 750px;
        height: 100%;
        margin: 0 auto;
        background-color: #f5dcb8;
        color: #b38448;

        .header {
            padding-bottom: .2rem;
            border-bottom: .16rem solid rgb(229, 182, 123);
        }

        .content {
            overflow: hidden;
            width: 9rem;
            height: 14.68rem;
            margin: .5rem auto 0;
            background: url("https://tianjipic.oss-cn-beijing.aliyuncs.com/projectAll/gylq/resbj.png") no-repeat -0.005rem 0/cover;

            .title {
                padding-top: .4rem;
                font-size: .4rem;

                h2 {
                    margin-top: .05rem;
                    font-weight: bold;
                    font-size: .56rem;
                }
            }

            .riddle {
                display: flex;
                margin-top: .1rem;
                height: 10.9rem;

                span {
                    display: block;
                    width: .7rem;
                    margin-top: .2rem;
                    line-height: .44rem;
                    font-size: .36rem;
                }

                .riddle-one {
                    display: flex;
                    flex-direction: row-reverse;
                    width: 5.35rem;
                    height: 100%;
                    .jieyue {
                        margin-right: .15rem;

                        .title {
                            padding-top: 0;
                            margin-top: .5rem;
                            overflow: hidden;

                            span {
                                float: right;
                                margin-top: 0;
                            }

                            span::before {
                                display: block;
                                content: '【';
                                transform: rotate(90deg);
                            }

                            span::after {
                                display: block;
                                content: '】';
                                transform: rotate(90deg);
                                height: .4rem;
                            }
                        }

                        .details {
                            display: flex;
                            flex-direction: column;
                            flex-wrap: wrap-reverse;
                            height: 8.7rem;

                            span {
                                margin: .3rem auto 0;
                            }
                        }
                    }

                    .xianji {
                        .title {
                            overflow: hidden;
                            margin-top: .1rem;
                            width: 25%;
                            margin-left: 75%;

                            span {
                                margin: 0 auto;
                            }

                            span::before {
                                display: block;
                                content: '【';
                                transform: rotate(90deg);
                            }

                            span::after {
                                display: block;
                                content: '】';
                                transform: rotate(90deg);
                                height: .4rem;
                            }
                        }

                        .xj-content {
                            display: flex;
                            flex-direction: row-reverse;
                            justify-content: space-between;

                            li {
                                width: 25%;

                                p {
                                    span {
                                        margin: .3rem auto 0;
                                    }
                                }
                            }
                        }
                    }
                }

                .riddle-two {
                    width: 1.85rem;
                    padding-top: .32rem;

                    p {
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: row-reverse;
                        flex-wrap: wrap;
                        width: 100%;
                        padding: 0 2%;
                    }

                    span {
                        width: 50%;
                        margin: .2rem auto;
                        font-size: .48rem;
                        line-height: .7rem;
                    }
                }

                .riddle-three {
                    width: 1.6rem;
                    padding-top: .1rem;

                    span {
                        margin: .5rem auto;
                        font-size: .4rem;
                        line-height: .6rem;
                    }

                    span:nth-last-of-type(1) {
                        padding: .2rem .1rem;
                        background-color: rgb(241, 207, 128);
                        border: 1px solid rgb(179, 132, 72);
                        border-radius: .2rem;
                    }
                }
            }

            .footer {
                margin-top: .28rem;
                text-align: left;

                p {
                    margin-top: .1rem;
                    text-indent: .5rem;
                    font-size: .44rem;

                    span:nth-of-type(1) {
                        margin-left: -2%;
                    }
                }
            }
        }

        .info {
            width: 9rem;
            margin: .4rem auto 0;

            .infolist {
                li {
                    h3 {
                        span {
                            font-size: .56rem;
                            font-weight: bold;
                            margin: 0 .6rem;
                        }
                    }

                    h3::before,
                    h3::after {
                        display: inline-block;
                        content: "";
                        width: 1.5rem;
                        height: .32rem;
                    }

                    h3::before {
                        background: url("data:image/png;base64,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") no-repeat top right/cover;
                    }

                    h3::after {
                        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAKCAYAAAFXtOeCAAAABGdBTUEAALGPC/xhBQAAAzZJREFUOBGNVEtrFEEQrpqeXSOS4MZHCMEIIniKJBe9eY4HQQRB8aoEESTqwb8gRMlB1CgYMeDBQxC8+TMMuUYNS1xiUPC1u9mZ6fb7amY2D4JJsTtdVV2Pr6qrW6WgpVen542NRCIvoquPZEJUZgIErFJ1Iv2TomBFPr0enQoSTogPkLxEcviaNh5KULibBdQDd7ssfTbo64tau/60j647UhnANj/Pjc37kIEHAOxEAOQll13EfNuoPlMLay9rO0ZnVSEUW6wsQlDKFgdrKjI8dE/qjLkFxuYkjbmTHe99JYG1RIUZOtETB0kCMQIVO2ORIaNpimzMrOCTEE/oyhO50Ov0PSuxEESFYGgrZJVmi6dA5zxOTyXPlR8AuoEcf9rh6OBtWdsMjrzF265cfjNS897NSkooqfi4KpIhvUMPSGmC/IhK8Dx0tDlHjH1W6cNCTPV28s2/V+JYLxJRBy1xnSYcnEQpBgOOCGNla8baQGyHgqfgFbHD+I6Iy0T1x7URrYaFwN7S0vt3x27+vFTu/2/Vb0/0VzUKvTyU8ugZg8kTZE9Tw8TyMAUqPehKDhMr5HbLLw5OygikLRRLO+xvwTdSNIsxEJUAUS/4gEG1SnM9knQS7FOHNgUkw1LbErEQGGLPtDR76kHtQOV+c72YFnoyCwHx0EgcR2s2eEMAPX+04ThlqV1cs+YHOgLsUjFyCl8bCGxYJxG36lR+t7Np8+067MIgtC4/Pz4WR3LQq+9DwqvOJ5ezwMmw6AVoGNoUyqoPYUq1+jE4zcSnKg6zyLtjhKnjXbTxLGY0haKUN/EYPJa3Ony9vmjbjWeVM5iM80km+zgifMzsDO0KgGX3QCu4E3GyYrzTgNfLjRIu5hztyK+KdROQeYvxqTnvz8HhCCSDWoSCCj7eq4v9j7Tj3w7dyl8cC77LRxvT8r0SST8AM4kRTwgYLH950t041tH85O25Y2GFjn7Eip/5l88h8XE8qC9tSh8q+RitZzI+MCkfYLIrRYN35BDelxuVIK2YQHEZlG8FiuAaA0gEPgLPi2M87Bz+psOe2dIevrZfrvQr9IylnQ2ZvjH2kPcL8p/dK2BW9A+2Q2KcTHY5bgAAAABJRU5ErkJggg==") no-repeat top left/cover;
                    }

                    p {
                        margin-top: .1rem;
                        text-align: left;
                        font-size: .36rem;
                        line-height: .8rem;
                        text-indent: 1rem;
                    }
                }
            }
        }

        .tese-again {
            position: fixed;
            top: 2rem;
            right: 0;
            background-color: red;
            border-top-left-radius: 0.15rem;
            border-bottom-left-radius: 0.15rem;

            p {
                width: .66rem;
                padding: .3rem 0;
                font-size: .36rem;
                line-height: .5rem;
                color: #fff;
            }
        }

        .more-test {
            .title {
                position: relative;

                span {
                    position: relative;
                    background-color: #f5dcb8;
                    padding: 0 .8rem;
                    font-size: .6rem;
                    font-weight: bold;
                }
            }

            .title::before {
                content: '';
                position: absolute;
                z-index: 0;
                display: block;
                top: 50%;
                width: 100%;
                height: .03rem;
                background-color: rgb(179, 132, 72);
                transform: translateY(-50%);
            }

            .other-test {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                width: 9.6rem;
                margin: .3rem auto 0;

                li {
                    width: 20%;
                    margin: 0 2.5% 0.3rem;
                    font-size: .36rem;

                    p {
                        margin-top: .1rem;
                    }

                    img {
                        display: block;
                        width: 100%;
                    }
                }
            }
        }

        .sadtips {
            display: none;
            position: fixed;
            top: 0;
            z-index: 100;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .7);

            img {
                margin-top: 50%;
                width: 50%;
            }

            p {
                width: 80%;
                margin: 0 auto;
                font-size: .5rem;
                color: rgba(200, 200, 200, 1);

                .timenum {
                    color: #fff;
                    font-size: .8rem;
                }
            }
        }
    }
</style>